import { useEffect, useState } from 'react';
import { Check, Copy, Link2 } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';
import { authService } from '@/services/authService';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';

/** A Consultant's reusable Express link, built on this site's own origin, with a one-click copy. */
export function ExpressLinkCard() {
  const { user, refreshUser } = useAuth();
  const [copied, setCopied] = useState(false);
  // The stored user is as of sign-in; someone made a Consultant since then gets the link without signing in again.
  useEffect(() => {
    authService.refreshUserData().then(refreshUser);
  }, [refreshUser]);
  if (!user?.isConsultant || !user.expressLinkCode) return null;

  const link = `${window.location.origin}/express/${user.expressLinkCode}`;
  const copy = async () => {
    await navigator.clipboard.writeText(link);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-lg font-semibold">
          <Link2 className="h-5 w-5" />
          Your Express link
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        <p className="text-sm text-muted-foreground">
          Send this link to a campaign. It sets up their account and walks them to their first text. You’re added to every
          campaign it creates.
        </p>
        <div className="flex flex-col gap-2 sm:flex-row sm:items-center">
          <code className="min-w-0 flex-1 break-all rounded-md border bg-muted/50 px-3 py-2 text-sm">{link}</code>
          <Button onClick={copy} variant="outline" className="shrink-0">
            {copied ? <Check className="h-4 w-4" /> : <Copy className="h-4 w-4" />}
            {copied ? 'Copied' : 'Copy link'}
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
